import type { SchemaFoundItem, SchemaFoundPage, SchemaSize } from '@zeed/content'
import type Tesseract from 'tesseract.js'

/** Convert Tesseract.js Page result to SchemaFoundPage. */
export function convertTesseractPage(
  page: Tesseract.Page,
  size: SchemaSize,
  pageNumber?: number,
): SchemaFoundPage {
  const items: SchemaFoundItem[] = []

  if (page.blocks) {
    for (const block of page.blocks) {
      for (const paragraph of block.paragraphs) {
        for (const line of paragraph.lines) {
          for (const word of line.words) {
            const item: SchemaFoundItem = {
              text: word.text,
              box: bboxToBox(word.bbox),
              cf: word.confidence / 100,
            }

            if (word.font_name) {
              item.font = {
                size: estimateFontSize(line.bbox),
                family: word.font_name,
              }
            }

            items.push(item)
          }
        }
      }
    }
  }

  return {
    size,
    page: pageNumber,
    items,
  }
}

/** Convert Tesseract bbox {x0,y0,x1,y1} in pixels to SchemaFoundBox (absolute pixels). */
function bboxToBox(
  bbox: Tesseract.Bbox,
): { x: number, y: number, w: number, h: number } {
  return {
    x: bbox.x0,
    y: bbox.y0,
    w: bbox.x1 - bbox.x0,
    h: bbox.y1 - bbox.y0,
  }
}

/** Estimate font size from line bbox height in pixels. */
function estimateFontSize(lineBbox: Tesseract.Bbox): number {
  return lineBbox.y1 - lineBbox.y0
}
